(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-box-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function decodeJSON(base64) {
      try {
        return JSON.parse(decodeURIComponent(escape(atob(base64))));
      } catch (e) {
        try { return JSON.parse(atob(base64)); } catch (e2) { return []; }
      }
    }

    function formatMoney(cents, currency, locale) {
      try {
        return new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
      } catch (e) {
        return '$' + ((cents || 0) / 100).toFixed(2);
      }
    }

    function GiftBoxBundle(root) {
      this.root = root;
      this.steps = decodeJSON(root.dataset.steps || '');
      this.goals = decodeJSON(root.dataset.goals || '');
      this.currency = root.dataset.currency;
      this.locale = root.dataset.locale;
      this.isStickyMobile = root.dataset.stickyMobile === 'true';
      this.items = {}; 
      this.currentTab = 0;
      
      this.cacheDom();
      this.bindEvents();
      this.render();
      
      var self = this;
      setTimeout(function() { self.handleSmartScroll(); }, 50);
    }

    GiftBoxBundle.prototype.cacheDom = function () {
      this.layoutEl = this.root.querySelector('.gbb-layout');
      this.summary = this.root.querySelector('.gbb-summary');
      this.summaryInner = this.root.querySelector('.gbb-summary-inner');
      
      this.tabs = Array.prototype.slice.call(this.root.querySelectorAll('.gbb-tab'));
      this.panels = Array.prototype.slice.call(this.root.querySelectorAll('.gbb-step-panel'));
      this.prevBtn = this.root.querySelector('.gbb-prev-btn');
      this.nextBtn = this.root.querySelector('.gbb-next-btn');
      
      this.summarySteps = Array.prototype.slice.call(this.root.querySelectorAll('.gbb-summary-step'));
      this.totalPriceEl = this.root.querySelector('.gbb-total-price');
      this.discountLineEl = this.root.querySelector('.gbb-discount-line');
      this.progressFill = this.root.querySelector('.gbb-progress-fill');
      this.progressMsgHeader = this.root.querySelector('.gbb-progress-msg-header');
      this.goalEls = Array.prototype.slice.call(this.root.querySelectorAll('.gbb-goal'));
      this.atcBtn = this.root.querySelector('.gbb-atc-btn');
      this.messageEl = this.root.querySelector('.gbb-message');
      
      this.summaryHeader = this.root.querySelector('.gbb-summary-header');
      this.summaryToggle = this.root.querySelector('.gbb-summary-toggle');
      this.summaryCollapsible = this.root.querySelector('.gbb-summary-collapsible');
    };

    GiftBoxBundle.prototype.bindEvents = function () {
      var self = this;
      
      // Tabs
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.goToTab(i); });
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.goToTab(self.currentTab - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.goToTab(self.currentTab + 1); });

      // Add Buttons
      this.root.querySelectorAll('.gbb-add-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) { self.handleToggle(e.currentTarget); });
      });

      // Show More Button Toggle
      this.root.querySelectorAll('.gbb-show-more-btn').forEach(function(btn) {
         btn.addEventListener('click', function(e) {
            var stepIndex = e.currentTarget.dataset.step;
            var panel = self.root.querySelector('.gbb-step-panel[data-step-index="' + stepIndex + '"]');
            panel.classList.toggle('is-showing-all');
            
            if (panel.classList.contains('is-showing-all')) {
               e.currentTarget.textContent = 'Show Less';
            } else {
               e.currentTarget.textContent = 'Show More';
               // Scroll back to top of panel smoothly when minimizing
               panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
         });
      });

      this.root.querySelectorAll('.gbb-variant-select').forEach(function (select) {
        select.addEventListener('change', function () { self.syncCardButton(select.closest('.gbb-product-card')); });
      });

      this.root.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('.gbb-remove-item');
        if (removeBtn) self.handleRemove(removeBtn);
      });

      this.summarySteps.forEach(function (stepEl) {
        var head = stepEl.querySelector('.gbb-summary-step-head');
        if (head) {
          head.addEventListener('click', function () { stepEl.classList.toggle('is-expanded'); });
        }
      });

      if (this.summaryHeader) {
        this.summaryHeader.addEventListener('click', function () {
          if (window.innerWidth < 900) {
            if (self.summaryToggle) self.summaryToggle.classList.toggle('is-open');
            if (self.summaryCollapsible) self.summaryCollapsible.classList.toggle('is-open');
            self.handleSmartScroll();
          }
        });
      }

      if (this.atcBtn) {
        this.atcBtn.addEventListener('click', function () { self.handleAddAllToCart(); });
      }
      
      // Smart Scroll Binding for mobile Sticky Drawer
      window.addEventListener('scroll', function() { self.handleSmartScroll(); }, { passive: true });
      window.addEventListener('resize', function() { self.handleSmartScroll(); }, { passive: true });
    };
    
    GiftBoxBundle.prototype.handleSmartScroll = function () {
      if (!this.summary || window.innerWidth >= 900) {
        if(this.summary) this.summary.classList.remove('is-fixed-viewport', 'is-absolute-bottom');
        if(this.layoutEl) this.layoutEl.style.paddingBottom = '0px';
        return;
      }
      if (!this.isStickyMobile) return;

      var rect = this.root.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      
      // Calculate dynamic height of drawer to clear bottom items properly
      var drawerHeight = this.summaryInner.offsetHeight || 150;
      this.layoutEl.style.paddingBottom = drawerHeight + 'px';

      // If Section top is above viewport bottom (scrolled in) AND Section bottom is below viewport bottom
      if (rect.top <= windowHeight && rect.bottom > windowHeight) {
        this.summary.classList.add('is-fixed-viewport');
        this.summary.classList.remove('is-absolute-bottom');
      } 
      // If Section bottom is visible inside viewport (reached the very bottom of the block)
      else if (rect.bottom <= windowHeight && rect.bottom > 0) {
        this.summary.classList.remove('is-fixed-viewport');
        this.summary.classList.add('is-absolute-bottom');
      } 
      // Scrolled completely past or above
      else {
        this.summary.classList.remove('is-fixed-viewport', 'is-absolute-bottom');
      }
    };

    GiftBoxBundle.prototype.goToTab = function (index) {
      if (index < 0 || index >= this.panels.length) return;
      this.currentTab = index;
      this.tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      this.panels.forEach(function (p, i) { p.hidden = i !== index; });
      if (this.prevBtn) this.prevBtn.disabled = index === 0;
      if (this.nextBtn) this.nextBtn.disabled = index === this.panels.length - 1;
      this.handleSmartScroll();
    };

    GiftBoxBundle.prototype.getCardVariant = function (card) {
      var select = card.querySelector('.gbb-variant-select');
      if (select) {
        var opt = select.options[select.selectedIndex];
        if (!opt || opt.disabled) return null;
        return {
          id: select.value,
          price: parseInt(opt.getAttribute('data-price'), 10) || 0,
          variantTitle: opt.textContent.replace('- Sold out', '').trim()
        };
      }
      var fixed = card.querySelector('.gbb-variant-fixed');
      if (fixed && fixed.value) {
        return { id: fixed.value, price: parseInt(fixed.getAttribute('data-price'), 10) || 0, variantTitle: '' };
      }
      return null;
    };

    GiftBoxBundle.prototype.handleToggle = function (btn) {
      var card = btn.closest('.gbb-product-card');
      var stepIndex = parseInt(card.dataset.step, 10);
      var variant = this.getCardVariant(card);
      if (!variant) return;

      if (!this.items[stepIndex]) this.items[stepIndex] = {};

      // Already in the box: clicking again removes it ("Remove from Box")
      if (this.items[stepIndex][variant.id]) {
        delete this.items[stepIndex][variant.id];
        this.clearMessage();
        this.syncCardButton(card);
        this.render();
        return;
      }

      var step = this.steps[stepIndex] || {};
      var currentCount = Object.keys(this.items[stepIndex]).length;
      if (step.maxRequired > 0 && currentCount >= step.maxRequired) {
        this.showMessage('You can only add up to ' + step.maxRequired + ' item(s) for "' + step.title + '".');
        return;
      }

      this.items[stepIndex][variant.id] = {
        variantId: variant.id,
        productId: card.dataset.productId,
        title: card.dataset.title,
        variantTitle: variant.variantTitle,
        price: variant.price,
        image: card.dataset.image
      };

      this.clearMessage();
      this.syncCardButton(card);
      this.render();
      
      if (this.summarySteps[stepIndex]) {
        this.summarySteps[stepIndex].classList.add('is-expanded');
      }
    };

    GiftBoxBundle.prototype.handleRemove = function (removeBtn) {
      var stepIndex = removeBtn.dataset.step;
      var variantId = removeBtn.dataset.variant;
      if (this.items[stepIndex]) delete this.items[stepIndex][variantId];
      this.syncAllButtons();
      this.render();
    };

    GiftBoxBundle.prototype.syncCardButton = function (card) {
      var stepIndex = parseInt(card.dataset.step, 10);
      var variant = this.getCardVariant(card);
      var btn = card.querySelector('.gbb-add-btn');
      if (!btn || !variant) return;
      var added = this.items[stepIndex] && this.items[stepIndex][variant.id];
      btn.classList.toggle('is-in-box', !!added);
      btn.textContent = added ? btn.dataset.removeLabel : btn.dataset.defaultLabel;
    };

    GiftBoxBundle.prototype.syncAllButtons = function () {
      var self = this;
      this.root.querySelectorAll('.gbb-product-card').forEach(function (card) { self.syncCardButton(card); });
    };

    GiftBoxBundle.prototype.computeTotals = function () {
      var total = 0;
      var stepsWithItems = 0;
      var self = this;
      this.steps.forEach(function (step, i) {
        var stepItems = self.items[i] || {};
        var keys = Object.keys(stepItems);
        if (keys.length > 0) stepsWithItems += keys.length;
        keys.forEach(function (k) { total += stepItems[k].price; });
      });
      return { total: total, stepsWithItems: stepsWithItems };
    };

    GiftBoxBundle.prototype.getReachedGoal = function (stepsWithItems) {
      var reached = null;
      this.goals.forEach(function (g) {
        if (stepsWithItems >= g.count) reached = g;
      });
      return reached;
    };

    GiftBoxBundle.prototype.getNextGoal = function (stepsWithItems) {
      var next = null;
      this.goals.forEach(function (g) {
        if (stepsWithItems < g.count && (!next || g.count < next.count)) next = g;
      });
      return next;
    };

    GiftBoxBundle.prototype.allMinimumsMet = function () {
      // A step only needs to satisfy its minimum once the shopper has started adding
      // items to it. Untouched steps (0 items) are optional, so the bundle can be
      // checked out with products from just 1 or 2 of the steps, not all of them.
      var self = this;
      return this.steps.every(function (step, i) {
        var count = self.items[i] ? Object.keys(self.items[i]).length : 0;
        if (count === 0) return true;
        if (!step.minRequired) return true;
        return count >= step.minRequired;
      });
    };

    GiftBoxBundle.prototype.render = function () {
      var self = this;
      var totals = this.computeTotals();

      this.summarySteps.forEach(function (panel) {
        var stepIndex = panel.dataset.stepIndex;
        var stepItems = self.items[stepIndex] || {};
        var keys = Object.keys(stepItems);
        var countEl = panel.querySelector('.gbb-summary-step-count-num');
        var headEl = panel.querySelector('.gbb-summary-step-head');
        
        if (countEl) countEl.textContent = keys.length;

        if (headEl) {
           if(keys.length > 0) headEl.classList.add('has-items');
           else headEl.classList.remove('has-items');
        }

        var itemsWrap = panel.querySelector('.gbb-summary-step-items');
        if (!itemsWrap) return;
        itemsWrap.innerHTML = '';
        if (keys.length === 0) {
          var empty = document.createElement('p');
          empty.className = 'gbb-summary-empty';
          empty.textContent = 'No product chosen';
          itemsWrap.appendChild(empty);
          return;
        }
        keys.forEach(function (variantId) {
          var item = stepItems[variantId];
          var row = document.createElement('div');
          row.className = 'gbb-summary-item';
          row.innerHTML =
            '<img src="' + item.image + '" alt="" loading="lazy">' +
            '<div class="gbb-summary-item-info">' +
              '<div>' + item.title + (item.variantTitle ? ' - ' + item.variantTitle : '') + '</div>' +
              '<div class="gbb-summary-item-price">' + formatMoney(item.price, self.currency, self.locale) + '</div>' +
            '</div>' +
            '<button type="button" class="gbb-remove-item" data-step="' + stepIndex + '" data-variant="' + variantId + '" aria-label="Remove">&times;</button>';
          itemsWrap.appendChild(row);
        });
      });

      var reached = this.getReachedGoal(totals.stepsWithItems);
      var next = this.getNextGoal(totals.stepsWithItems);
      
      if (this.progressFill) {
        var highestGoalCount = this.goals.length > 0 ? this.goals[this.goals.length - 1].count : 3;
        var fillPct = Math.min(100, (totals.stepsWithItems / highestGoalCount) * 100);
        this.progressFill.style.width = fillPct + '%';
      }
      this.goalEls.forEach(function (el) {
        var count = parseInt(el.dataset.count, 10);
        el.classList.toggle('is-reached', totals.stepsWithItems >= count);
      });
      if (this.progressMsgHeader) {
        if (next) {
          var remaining = next.count - totals.stepsWithItems;
          this.progressMsgHeader.textContent = 'Add ' + remaining + ' more to get ' + next.label + '.';
        } else if (reached) {
          this.progressMsgHeader.textContent = 'Unlocked maximum ' + reached.label + '!';
        } else {
          this.progressMsgHeader.textContent = '';
        }
      }

      if (this.totalPriceEl) this.totalPriceEl.textContent = formatMoney(totals.total, this.currency, this.locale);
      if (this.discountLineEl) {
        if (reached) {
          this.discountLineEl.hidden = false;
          this.discountLineEl.textContent = reached.discount + '% off applied at checkout';
        } else {
          this.discountLineEl.hidden = true;
        }
      }

      if (this.atcBtn) {
        var hasAnyItem = totals.stepsWithItems > 0;
        this.atcBtn.disabled = !(hasAnyItem && this.allMinimumsMet());
      }
      
      this.handleSmartScroll();
    };

    GiftBoxBundle.prototype.showMessage = function (text) {
      if (!this.messageEl) return;
      this.messageEl.textContent = text;
      this.messageEl.hidden = false;
    };

    GiftBoxBundle.prototype.clearMessage = function () {
      if (!this.messageEl) return;
      this.messageEl.hidden = true;
    };

    GiftBoxBundle.prototype.handleAddAllToCart = function () {
      var self = this;
      var allItems = [];
      this.steps.forEach(function (step, i) {
        var stepItems = self.items[i] || {};
        Object.keys(stepItems).forEach(function (variantId) {
          allItems.push({
            id: variantId,
            quantity: 1,
            properties: { 'Bundle Step': step.title }
          });
        });
      });
      if (allItems.length === 0) return;

      this.atcBtn.disabled = true;
      this.atcBtn.classList.add('is-loading');
      this.clearMessage();

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: allItems })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) { throw new Error(err.description || 'Could not add items to cart.'); });
          }
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var totals = self.computeTotals();
          var reached = self.getReachedGoal(totals.stepsWithItems);
          if (reached && reached.code) {
            window.location.href = routeRoot + 'discount/' + encodeURIComponent(reached.code) + '?redirect=' + encodeURIComponent(routeRoot + 'cart');
          } else {
            window.location.href = routeRoot + 'cart';
          }
        })
        .catch(function (err) {
          self.showMessage(err.message || 'Something went wrong. Please try again.');
          self.atcBtn.disabled = false;
          self.atcBtn.classList.remove('is-loading');
        });
    };

    function initAll(scope) {
      (scope || document).querySelectorAll('.gbb-root').forEach(function (root) {
        if (root.__gbbInstance) return;
        root.__gbbInstance = new GiftBoxBundle(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
